export { default as default } from '../modules/react/Input.js'